import config from 'config/config'
import {
  classNames,
  sortableListDragSourceDragMarker,
  sortableListDropTargetDragMarker,
} from 'lib/utilities'
import React from 'react'
import { DragSource, DropTarget } from 'react-dnd'
import { Icon, Table } from 'semantic-ui-react'

class CategoriesRow extends React.Component {
  render() {
    const {
      index,
      dragMarker = {},
      category = {},
      active,
      handleSelect,
    } = this.props //ownProps
    const { isDragging, connectDragSource, connectDropTarget } = this.props //DragSource,DropTarget
    let rowClass = []
    if (isDragging) rowClass.push('isDragging')
    if (category.link_target_id) rowClass.push('virtual')
    if (!category.visible) rowClass.push('invisible')
    if (dragMarker.index === index) rowClass.push(dragMarker.position)
    if (active) rowClass.push('active')
    return connectDragSource(
      connectDropTarget(
        <tr
          onClick={() => handleSelect(category.id)}
          className={classNames(rowClass)}>
          <Table.Cell collapsing className="draggable">
            <Icon {...config.icons.draggable} link />
          </Table.Cell>
          <Table.Cell children={category.title_de} />
          <Table.Cell collapsing>
            {category.link_target_id > 0 && <Icon name="external" />}
          </Table.Cell>
        </tr>
      )
    )
  }
}

CategoriesRow = DropTarget(
  (props) => props.dndName,
  sortableListDropTargetDragMarker,
  (connect) => ({ connectDropTarget: connect.dropTarget() })
)(CategoriesRow)
CategoriesRow = DragSource(
  (props) => props.dndName,
  sortableListDragSourceDragMarker,
  (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  })
)(CategoriesRow)

export default CategoriesRow



// WEBPACK FOOTER //
// ./src/components/admin/Categories/CategoriesRow.jsx